import React, { Component } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';

import Loader from '../loader/loader.component';

// styles , icons and images
import { Button } from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import dots from '../record/images/more.png';
import './preview.style.css';



// this component represents the review&publish part of the create and edit visume page 

class Preview extends Component {
    constructor() {
        super();
        this.state = {
            title: '',
            questionSelected: '',
            status: 'Publish',
            showLoader: false
        }
    }

    componentDidMount() {
        var btns = document.querySelectorAll(".dots-btn");
        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                this.querySelector(".custom-list").classList.toggle("d-none");
            });
        }
    }
    componentWillReceiveProps(props) {
        if (props.data) {
            this.setState({ ...this.state, bio: props.data, status: props.status  , bioFor : props.bioFor , applicationId : props.applicationId});

            if (props.data.video_id !== null && this.state.CompileButton === true) {
                document.querySelector('.preview .loading').classList.add('d-none');
                this.setState({ ...this.state, showLoader: false, compiledVideo: true, bio: props.data })
            }
        }
    }
    handleClick = (e) => {
        let elem = e.currentTarget;
        if (elem.querySelector('.custom-list')) {
            elem.querySelector('.custom-list').classList.toggle('d-none')
        }
    }
    closeAllMenues = () => {
        let menues = document.querySelectorAll('.custom-list');

        menues.forEach(menu => menu.classList.add('d-none'))
    }
    render() {
        if (!this.state.bio) {
            return (
                <div><h5 className="text-dark">Loading....</h5></div>
            )
        }
        else {
            const handleClose = () => this.setState({ ...this.state, show: false });
            const handleCloseDeleteModal = () => this.setState({ ...this.state, showDeleteModal: false });
            const handelCloseCompiledVideo = () => this.setState({ ...this.state, compiledVideo: false });

            return (
                <div className="pb-3">
                    <Container className="overview preview shadow border-rounded">
                        {/* merge videos loader */}
                        <Loader
                            visible={this.state.showLoader}
                            text="Your Visume is being created it may take a few minutes. Don't close this screen"
                        />
                        <Row>
                            <Col className="bg-light border-bottom p-5" sm={12}>
                                <div className="title">
                                    <h4 className="text-dark">Review & Publish</h4>
                                    <p className="text-grey mb-0">Make Sure all things are good</p>
                                </div>
                            </Col>
                            <Col className="p-5">
                                {this.state.bio.questions.map(question => 
                                    {   // make sure that all questions have video  
                                        // onclick  video -> save the question on questionSelected variable and show a view video modal 
                                        // on click delete option -> save the question on questionSelected variable and show a delete video modal 
                                        if (question.video) 
                                            {return (
                                                <Row className="p-0 m-0 align-items-center">
                                                    <Col sm={2} xs={3} className="p-0">
                                                        <button
                                                            type="button"
                                                            className="bg-transparent border-0 p-0 play-icon-container"
                                                            onClick={e => {
                                                                this.setState({ ...this.state, questionSelected: question, show: true })
                                                            }}>
                                                            <img src={question.video.frame.url} alt="video poster" className="rounded" width="100%" style={{ maxHeight: '4.5rem' }} />
                                                            <div className="text-white play-icon row m-0 align-items-center">
                                                                <PlayCircleOutlineIcon className="col" />
                                                            </div>
                                                        </button>
                                                    </Col>
                                                    <Col sm={9} xs={7} className="p-0">
                                                            <p className="d-inline-block pl-2 captialize">
                                                            {question.title}
                                                            {/* <p className="text-grey small mb-0">{question.maximum_time}</p> */}
                                                        </p>
                                                    </Col>
                                                    <Col sm={1} xs={1} className="dots text-right">
                                                        <button
                                                            type="button"
                                                            className="more-btn"
                                                            onClick={this.handleClick}>
                                                            <ul className="shadow custom-list d-none" style={{ left: "unset", right: "0rem" }}>
                                                                <li className="list-style-none text-center delete-option p-0">
                                                                    <button
                                                                        className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            let list = document.getElementById("left-tabs-example");
                                                                            let nav_items = list.querySelectorAll(".nav-item a");
                                                                            nav_items[1].click();
                                                                        }}
                                                                    >Edit</button>
                                                                </li>
                                                                <li className="list-style-none text-center delete-option p-0">
                                                                    <button
                                                                        className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3"
                                                                        type="button"
                                                                        onClick={e => {
                                                                            this.setState({ ...this.state, questionSelected: question, showDeleteModal: true })
                                                                        }}
                                                                    >Delete</button>
                                                                </li>
                                                            </ul>
                                                            <img src={dots} alt="more" />
                                                        </button>
                                                    </Col>
                                                    <div className="w-100 pb-3"></div>
                                                </Row>
                                    )}}
                                )}
                            </Col>
                            {(this.state.questionSelected) ?
                                (
                                    //show video modal 
                                    // show delete question modal
                                    <div>
                                        <Modal
                                            size="lg"
                                            aria-labelledby="contained-modal-title-vcenter pr-0"
                                            centered
                                            className="row m-0 modal-video"
                                            show={this.state.show}
                                            onHide={handleClose}>
                                            <Col xs={12} className="p-0">
                                                <Modal.Body className="p-0 bg-white rounded border-b-0">
                                                    <Col xs={12} className="text-left  bold  captialize">
                                                        <h6 className='mb-0 pt-3 pb-3'>{this.state.questionSelected.title}</h6>
                                                    </Col>
                                                    <Col xs={12} className="p-0 bg-black rounded">
                                                        <video controls autoPlay title={this.state.questionSelected.title} src={this.state.questionSelected.video.url} className='iframe-sm ' width="100%" style={{ maxHeight: '33rem' }}></video>
                                                    </Col>
                                                </Modal.Body>
                                            </Col>
                                        </Modal>
                                        <Modal
                                            size="md"
                                            centered
                                            className="row m-0 custom-modal-delete pr-0"
                                            show={this.state.showDeleteModal}
                                            onHide={handleCloseDeleteModal}>
                                            <Col xs={12} className="p-0">
                                                <Modal.Body className="p-1">
                                                    <h6>Are you sure you want to delete this question ?</h6>
                                                </Modal.Body>
                                                <Modal.Footer className="custom pt-3 pl-0 pr-0 pb-0">
                                                    <Row className="m-0 w-100">
                                                        <Col xs={6} className="text-left p-0">
                                                            <Button
                                                                type="button"
                                                                size="large"
                                                                className="btn-white-outline  pr-5 pl-5" variant="contained"
                                                                onClick={() => {
                                                                    handleCloseDeleteModal();
                                                                }}>
                                                                No
                                                                </Button>
                                                        </Col>
                                                        <Col xs={6} className="text-right p-0">
                                                            <Button
                                                                type="button"
                                                                size="large"
                                                                className="btn-orange-gradiant pr-4 pl-4" variant="contained"
                                                                onClick={() => {
                                                                    this.props.delete_question({
                                                                        variables: {
                                                                            "question_id": this.state.questionSelected.id
                                                                        }
                                                                    }).then((res) => {
                                                                        if (res.data.questionDelete.Status.code === 200) {
                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                            let list = document.getElementById("left-tabs-example");
                                                                            let nav_items = list.querySelectorAll(".nav-item a");
                                                                            nav_items[1].click();

                                                                            nav_items[2].setAttribute("aria-disabled", "true")
                                                                            nav_items[2].classList.add("disabled")
                                                                            nav_items[3].setAttribute("aria-disabled", "true")
                                                                            nav_items[3].classList.add("disabled")
                                                                        }
                                                                    }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                                    handleCloseDeleteModal();
                                                                }}>
                                                                Yes, Delete
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Modal.Footer>
                                            </Col>
                                        </Modal>
                                        </div>
                                ) : ''
                            }
                        </Row>
                    </Container>
                    {(this.state.bioFor === 'applyJob') ?
                        <div className="w-100 row m-0 mt-3">
                            <Col className="p-0">
                                <Button
                                    size="large"
                                    className="btn-white-outline pr-5 pl-5 preview-back"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.closeAllMenues();
                                        let list = document.getElementById("left-tabs-example");
                                        let nav_items = list.querySelectorAll(".nav-item a");
                                        nav_items[1].click();
                                    }}
                                    variant="contained">Back</Button>
                            </Col>
                            <Col className="p-0 text-right">
                                 <Button
                                size="large"
                                className="btn-orange-gradiant pr-4 pl-4 publish"
                                onClick={e => 
                                    {
                                        let id = this.state.bio.id
                                        if (id) {
                                            this.props.compile_video({
                                                variables: {
                                                    bio_id: id,
                                                }
                                            }).then((res) => {
                                                if (res.data.bioWaitForProcess.Status.code === 200) {
                                                    document.querySelector('.preview .loading').classList.remove('d-none');
                                                    this.setState({ ...this.state, showLoader: true, CompileButton: true })
                                                }

                                            })
                                                .catch((err) => this.setState({ ...this.state, errorMessage: "There is something wrong happened, please try again later" }));
                                        }
                                    }}
                                variant="contained"
                            >Compile
                            </Button>
                            </Col>
                        </div>
                        :
                        <div className="w-100 row m-0">
                            <Col md="7" xs="6" className="d-inline-block p-0 pt-4 text-left order-sm-1 order-1">
                                <Button
                                    size="large"
                                    className="btn-white-outline pr-5 pl-5 preview-back"
                                    onClick={e => {
                                        e.preventDefault();
                                        let list = document.getElementById("left-tabs-example");
                                        let nav_items = list.querySelectorAll(".nav-item a");
                                        nav_items[2].click();
                                    }}
                                    variant="contained">Back</Button>
                            </Col>
                            <Col md="3" xs="12" className="d-inline-block   pt-4 text-right text-responsive-center  order-sm-2  order-3">
                                <Button
                                    size="large"
                                    className="btn-white-outline pr-3 pl-3"
                                    onClick={e => {
                                        this.closeAllMenues();
                                        this.props.draft({
                                            variables: {
                                                "bio_id": this.state.bio.id
                                            }
                                        }).then((data) => {
                                            // make sure that camera is stopped 
                                            var video = document.querySelector('video');
                                            const stream = video.srcObject;
                                            if (stream) {
                                                const tracks = stream.getTracks();
                                                tracks.forEach(function (track) {
                                                    track.stop();
                                                    video.srcObject = null;
                                                });
                                            }
                                            if (data) {
                                                this.props.history.push({
                                                    pathname: '/visumes',
                                                })
                                            }

                                        }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                    }}
                                    variant="contained"
                                >Save as Draft
                                </Button>
                            </Col>
                            <Col md="2" xs="6" className="d-inline-block p-0 pt-4  text-right  order-sm-3 order-2">
                                <Button
                                    size="large"
                                    className="btn-orange-gradiant pr-3 pl-3 publish w-100 w-xs-75"
                                    onClick={e => 
                                        {
                                            this.closeAllMenues();
                                            let id = this.state.bio.id
                                            if (id) {
                                                this.props.compile_video({
                                                    variables: {
                                                        bio_id: id,
                                                    }
                                                }).then((res) => {
                                                    if (res.data.bioWaitForProcess.Status.code === 200) {
                                                        document.querySelector('.preview .loading').classList.remove('d-none');
                                                        this.setState({ ...this.state, showLoader: true, CompileButton: true })
                                                    }

                                                })
                                                    .catch((err) => this.setState({ ...this.state, errorMessage: "There is something wrong happened, please try again later" }));
                                            }
                                        }}
                                    variant="contained"
                                >Compile
                                </Button>
                            </Col>
                        </div>
                    }
                    {/* show mereged video */}
                    {(this.state.bio.video) ?
                        <Modal
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter pr-0"
                            centered
                            className="row m-0 modal-video"
                            show={this.state.compiledVideo}
                            onHide={handelCloseCompiledVideo}>
                            <Col xs={12} className="p-0">
                                <Modal.Body className="p-0 bg-white rounded border-0">
                                    <Row xs={12} className="p-0 bg-black rounded m-0">
                                        <video controls autoPlay title={this.state.bio.title} src={this.state.bio.video.url} className='iframe-sm' width="100%" style={{ maxHeight: '33rem' }}></video>
                                    </Row>
                                    {(this.state.bioFor === 'applyJob') ? 
                                        <Row className="p-3 m-0 ">
                                            <Col className="p-0 text-left">
                                                <Button
                                                    size="large"
                                                    className="btn-white-outline pr-5 pl-5 preview-back"
                                                    variant="contained"
                                                    onClick={handelCloseCompiledVideo}
                                                >Back</Button>
                                            </Col>
                                            <Col  className="p-0 text-right">
                                                <Button
                                                    size="large"
                                                    className="btn-orange-gradiant pr-5 pl-5 "
                                                    onClick={e => {
                                                        let id = this.state.applicationId
                                                        console.log(id)
                                                        if (id) {
                                                            this.props.application_done({
                                                                variables: {
                                                                    application_id : id
                                                                }
                                                            }).then((data) => {
                                                                // make sure that camera is stopped 
                                                                var video = document.querySelector('video');
                                                                const stream = video.srcObject;
                                                                if (stream) {
                                                                    const tracks = stream.getTracks();
                                                                    tracks.forEach(function (track) {
                                                                        track.stop();
                                                                        video.srcObject = null;
                                                                    });
                                                                }
                                                                if (data) {
                                                                    this.props.history.push({
                                                                        pathname: '/homepage',
                                                                    })
                                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                }
                                                            }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                        }
                                                    }}
                                                    variant="contained"
                                                >Apply
                                                </Button>
                                            </Col>                                          
                                        </Row>
                                        : 
                                        <Row xs={12} className="p-3 m-0">
                                            <Col md="7" xs="6" className="d-inline-block p-0 text-left order-sm-1 order-1">
                                                <Button
                                                    size="large"
                                                    className="btn-white-outline pr-5 pl-5 preview-back"
                                                    variant="contained"
                                                    onClick={handelCloseCompiledVideo}
                                                >Close</Button>
                                            </Col>
                                            <Col md="3" xs="12"
                                                className="d-inline-block   text-right text-responsive-center  order-sm-2  order-3 mt-3-responsive">
                                                <Button
                                                    size="large"
                                                    className="btn-white-outline pr-3 pl-3 mr-3-responsive"
                                                    onClick={e => {
                                                        this.props.draft({
                                                            variables: {
                                                                "bio_id": this.state.bio.id
                                                            }
                                                        }).then((data) => {
                                                            if (data) {
                                                                this.props.history.push({
                                                                    pathname: '/Visumes',
                                                                })
                                                            }

                                                        }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                    }}
                                                    variant="contained">
                                                    Save as Draft
                                            </Button>
                                            </Col>
                                            <Col md="2" xs="6" className="d-inline-block p-0   text-right  order-sm-3 order-2">
                                                <Button
                                                    size="large"
                                                    className="btn-orange-gradiant pr-1 pl-1 publish w-100 w-xs-75"
                                                    onClick={e => {
                                                        let id = this.state.bio.id
                                                        if (id) {
                                                            this.props.publish({
                                                                variables: {
                                                                    "bio_id": this.state.bio.id
                                                                }
                                                            }).then((data) => {
                                                                // make sure that camera is stopped 
                                                                var video = document.querySelector('video');
                                                                const stream = video.srcObject;
                                                                if (stream) {
                                                                    const tracks = stream.getTracks();
                                                                    tracks.forEach(function (track) {
                                                                        track.stop();
                                                                        video.srcObject = null;
                                                                    });
                                                                }
                                                                if (data) {
                                                                    this.props.history.push({
                                                                        pathname: '/Visumes',
                                                                    })
                                                                }
                                                            }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                        }
                                                    }}
                                                    variant="contained"
                                                >{this.state.status || "Publish"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    }
                                </Modal.Body>
                            </Col>
                        </Modal>
                        : ''
                    }
                    

                </div>
            );
        }
    }
}
const GET_BIOGRAPHIES = gql`
query($id : Int !){
    bioYours(id: $id){
        id
        title
        brif
        is_Draft
        created_at
        updated_at
        questions
        { id    
          title
          maximum_time
          video{
            url
            duration
            frame{
              url
            }
          }
        }
    }
  }
`

const DELETE_QUESTION = gql`
mutation($question_id :  Int ! ){
    questionDelete(Inputs:{
      id: $question_id
    }){
      Status{
        code
      }
    }
  }
  
`

const PUBLISH = gql`
mutation($bio_id : Int !){
    bioEdit(Inputs : {
      bio:{id : $bio_id}
     is_Draft : false
    }){
      Status{
        code
      }
      bio{
        id
      }
    }
  }
`

const DRAFT = gql`
mutation($bio_id : Int !){
    bioEdit(Inputs : {
      bio:{id : $bio_id}
     is_Draft : true
    }){
      Status{
        code
      }
      bio{
        id
      }
    }
  }
`

const COMPILE_VIDEO = gql`
    mutation($bio_id : Int !){
        bioWaitForProcess(Inputs:{
        id : $bio_id
        }){
        Status{
            code
        }
        bio{
            id
        }
        }
    }
`

const APPLICATION_DONE =gql`
    mutation($application_id : Int){
        applicationDone(Inputs: {
        id : $application_id
        }){
        Status{
            code
            message
        }
        Application{
            id
            answered_by{
            email
            }
            user{
            email
            }
            company{
            name
            }
        }
        }
}`

export default compose(
    graphql(GET_BIOGRAPHIES, {
        name: "get_biographies"
    }),
    graphql(DELETE_QUESTION, {
        name: "delete_question"
    }),
    graphql(PUBLISH, {
        name: "publish"
    }),
    graphql(DRAFT, {
        name: "draft"
    }),
    graphql(COMPILE_VIDEO, {
        name: "compile_video"
    }),
    graphql(APPLICATION_DONE, {
        name: "application_done"
    }),
)(withRouter(Preview));